// RouteComponent.jsx
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "../pages/Home";
import Blog from "../pages/Blog";
import Navbar from "../components/Navbar";
import PrivateHypnotherapy from "../pages/PrivateHypnotherapy";
import Counselling from "../pages/Counselling";
import Awareness from "../pages/Awareness";
import Insomnia from "../pages/Insmonia";
import Meditation from "../pages/Meditation";
import ScienceOfYoga from "../pages/ScienceOfYoga";
import AboutUs from "../pages/AboutUs";
import Contact from "../pages/Contact";
import WhatsAppChatButton from "../components/WhatsAppChatButton";
import Classes from "../pages/Classes";

const RouteComponent = () => (
  <Router>
     <Navbar />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/classes" element={<Classes />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blogs" element={<Blog />} />
      <Route path="/privateHypnotherapy" element={<PrivateHypnotherapy />} />
      <Route path="/personalCounselling" element={<Counselling />} />
      <Route path="/awareness" element={<Awareness />} />
      <Route path="/insomnia" element={<Insomnia />} />
      <Route path="/medidation" element={<Meditation />} />
      <Route path="/scienceOfYoga" element={<ScienceOfYoga />} />

    </Routes>
    <WhatsAppChatButton/>
  </Router>
);

export default RouteComponent;
